(function () {
  // Set this to wherever you uploaded the php-backend folder
  const REVIEWS_ENDPOINT = 'https://oricmeta.com/reviews-api';

  const section = document.getElementById('customer-reviews');
  if (!section) return;

  // Move popups out of the section to <body> so they are never trapped
  // under the section / theme wrappers (fixes z-index + mobile not opening)
  ['cr-modal', 'cr-detail-modal'].forEach(function (id) {
    const el = document.getElementById(id);
    if (el && el.parentElement !== document.body) {
      document.body.appendChild(el);
    }
  });

  const track = document.getElementById('cr-track');
  const prevBtn = section.querySelector('.cr-arrow--prev');
  const nextBtn = section.querySelector('.cr-arrow--next');

  function scrollByCard(direction) {
    const card = track.querySelector('.cr-card');
    if (!card) return;
    const amount = card.getBoundingClientRect().width + 20;
    track.scrollBy({ left: direction * amount, behavior: 'smooth' });
  }

  prevBtn && prevBtn.addEventListener('click', () => scrollByCard(-1));
  nextBtn && nextBtn.addEventListener('click', () => scrollByCard(1));

  // Toggleable voting, remembered per-browser via localStorage.
  // Key: reviewId → 'up' or 'down' (their current vote), or absent if none.
  const VOTE_STORAGE_KEY = 'cr_voted_reviews';

  function getVotedMap() {
    try {
      return JSON.parse(localStorage.getItem(VOTE_STORAGE_KEY)) || {};
    } catch (e) {
      return {};
    }
  }

  function setVotedMap(votes) {
    try {
      localStorage.setItem(VOTE_STORAGE_KEY, JSON.stringify(votes));
    } catch (e) {}
  }

  function getReviewButtons(reviewId) {
    return section.querySelectorAll(`.cr-vote[data-review-id="${reviewId}"]`);
  }

  function applyVotedState() {
    const votes = getVotedMap();
    section.querySelectorAll('.cr-vote').forEach((btn) => {
      const reviewId = btn.dataset.reviewId;
      btn.classList.toggle('is-voted', votes[reviewId] === btn.dataset.vote);
    });
  }

  applyVotedState();

  // Vote buttons (thumbs up/down) — click again to remove your vote,
  // click the other button to switch it. Optimistic UI, reverted on failure.
  section.addEventListener('click', function (e) {
    const voteBtn = e.target.closest('.cr-vote');
    if (!voteBtn) return;
    if (voteBtn.disabled) return;

    const reviewId = voteBtn.dataset.reviewId;
    const direction = voteBtn.dataset.vote;
    const votes = getVotedMap();
    const previousVote = votes[reviewId] || null;

    const buttons = getReviewButtons(reviewId);
    const upBtn = Array.from(buttons).find((b) => b.dataset.vote === 'up');
    const downBtn = Array.from(buttons).find((b) => b.dataset.vote === 'down');
    const upCountEl = upBtn.querySelector('span');
    const downCountEl = downBtn.querySelector('span');
    const prevUpValue = Number(upCountEl.textContent);
    const prevDownValue = Number(downCountEl.textContent);

    buttons.forEach((b) => { b.disabled = true; });

    // Optimistic local update, mirroring the server's logic
    let optimisticUp = prevUpValue;
    let optimisticDown = prevDownValue;
    let optimisticVote = direction;

    if (previousVote === direction) {
      if (direction === 'up') optimisticUp = Math.max(0, prevUpValue - 1);
      else optimisticDown = Math.max(0, prevDownValue - 1);
      optimisticVote = null;
    } else if (previousVote === null) {
      if (direction === 'up') optimisticUp = prevUpValue + 1;
      else optimisticDown = prevDownValue + 1;
    } else {
      if (direction === 'up') {
        optimisticUp = prevUpValue + 1;
        optimisticDown = Math.max(0, prevDownValue - 1);
      } else {
        optimisticDown = prevDownValue + 1;
        optimisticUp = Math.max(0, prevUpValue - 1);
      }
    }

    upCountEl.textContent = optimisticUp;
    downCountEl.textContent = optimisticDown;
    upBtn.classList.toggle('is-voted', optimisticVote === 'up');
    downBtn.classList.toggle('is-voted', optimisticVote === 'down');

    fetch(REVIEWS_ENDPOINT + '/vote.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ reviewId, direction, previousVote })
    })
      .then((res) => {
        if (!res.ok) throw new Error('Vote failed');
        return res.json();
      })
      .then((data) => {
        if (typeof data.thumbsUp === 'number') upCountEl.textContent = data.thumbsUp;
        if (typeof data.thumbsDown === 'number') downCountEl.textContent = data.thumbsDown;

        const votesNow = getVotedMap();
        if (data.newVote) {
          votesNow[reviewId] = data.newVote;
        } else {
          delete votesNow[reviewId];
        }
        setVotedMap(votesNow);
        applyVotedState();
      })
      .catch(() => {
        // Revert everything if the save failed
        upCountEl.textContent = prevUpValue;
        downCountEl.textContent = prevDownValue;
        applyVotedState();
      })
      .finally(() => {
        buttons.forEach((b) => { b.disabled = false; });
      });
  });

  // Modal
  const modal = document.getElementById('cr-modal');
  const backdrop = document.getElementById('cr-modal-backdrop');
  const closeBtn = document.getElementById('cr-modal-close');
  const openWriteBtn = document.getElementById('cr-open-write');
  const modalTitle = document.getElementById('cr-modal-title');

  function openModal() {
    if (!modal) return;
    if (modalTitle) modalTitle.textContent = 'Write a review';
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    if (!modal) return;
    modal.hidden = true;
    document.body.style.overflow = '';
  }

  openWriteBtn && openWriteBtn.addEventListener('click', openModal);
  closeBtn && closeBtn.addEventListener('click', closeModal);
  backdrop && backdrop.addEventListener('click', closeModal);

  // Full Review detail modal
  const detailModal = document.getElementById('cr-detail-modal');
  const detailBackdrop = document.getElementById('cr-detail-modal-backdrop');
  const detailCloseBtn = document.getElementById('cr-detail-modal-close');
  const detailStars = document.getElementById('cr-detail-stars');
  const detailName = document.getElementById('cr-detail-name');
  const detailTitle = document.getElementById('cr-detail-modal-title');
  const detailBody = document.getElementById('cr-detail-body');
  const detailPhoto = document.getElementById('cr-detail-photo');

  function openDetailModal(link) {
    const rating = Math.max(0, Math.min(5, Number(link.dataset.rating) || 0));
    detailStars.textContent = '★'.repeat(rating) + '☆'.repeat(5 - rating);
    detailName.textContent = link.dataset.name || '';
    detailTitle.textContent = link.dataset.title || '';
    detailBody.textContent = link.dataset.body || '';

    if (link.dataset.photo) {
      detailPhoto.src = link.dataset.photo;
      detailPhoto.hidden = false;
    } else {
      detailPhoto.hidden = true;
      detailPhoto.removeAttribute('src');
    }

    detailModal.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  function closeDetailModal() {
    detailModal.hidden = true;
    document.body.style.overflow = '';
  }

  section.addEventListener('click', function (e) {
    const link = e.target.closest('.cr-full-review');
    if (!link) return;
    e.preventDefault();
    openDetailModal(link);
  });

  detailCloseBtn && detailCloseBtn.addEventListener('click', closeDetailModal);
  detailBackdrop && detailBackdrop.addEventListener('click', closeDetailModal);

  // Star input
  const starButtons = document.querySelectorAll('.cr-star-choice');
  const ratingInput = document.getElementById('cr-rating-value');

  starButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
      const value = Number(btn.dataset.value);
      ratingInput.value = value;
      starButtons.forEach((b) => {
        const active = Number(b.dataset.value) <= value;
        b.classList.toggle('is-active', active);
        b.textContent = active ? '★' : '☆';
      });
    });
  });

  // Form submit
  const form = document.getElementById('cr-review-form');
  const statusEl = document.getElementById('cr-form-status');
  const submitBtn = document.getElementById('cr-submit-btn');

  form && form.addEventListener('submit', async function (e) {
    e.preventDefault();
    if (!ratingInput.value) {
      statusEl.textContent = 'Please select a star rating.';
      return;
    }

    submitBtn.disabled = true;
    statusEl.textContent = 'Submitting…';

    try {
      const formData = new FormData(form);
      const res = await fetch(REVIEWS_ENDPOINT + '/submit.php', {
        method: 'POST',
        body: formData
      });

      if (!res.ok) throw new Error('Request failed');

      statusEl.textContent = 'Thanks! Your review is pending approval.';
      form.reset();
      starButtons.forEach((b) => { b.classList.remove('is-active'); b.textContent = '☆'; });
      setTimeout(closeModal, 1800);
    } catch (err) {
      statusEl.textContent = 'Something went wrong — please try again.';
    } finally {
      submitBtn.disabled = false;
    }
  });
})();